import { notLoggedInExceptions } from 'resources/reroute-exceptions'
import { getOrgMeta } from 'util/org-meta'

const isException = notLoggedInExceptions.some(exception =>
  window.location.hash.includes(exception)
)

const notLoggedIn = startApp => {
  const checkResetPassUrlForTokens = () => {
    const locationHref = window.location.href
    const pathname = window.location.pathname
    // checks added for, if url is reset url and url contains token
    if (
      pathname.indexOf('/membership') !== -1 &&
      locationHref.indexOf('/reset/') !== -1 &&
      locationHref.indexOf('password') === -1
    ) {
      // retrive token from url hash
      const urlParams = window.location.hash && window.location.hash.split('/')
      const passwordResetToken =
        urlParams.length && urlParams[urlParams.length - 1]
      if (passwordResetToken) {
        sessionStorage.setItem('token', passwordResetToken)
        window.location = '/membership/#/reset/password'
      }
    }
  }
  const loadHandler = evt => {
    if (evt.target.status === 200) {
      const config = JSON.parse(evt.target.response)
      const orgSlug = config.orgslug
      getOrgMeta(orgSlug, meta => {
        const homepageEnabled =
          meta && meta._priv && meta._priv['feature:homepage'] === true
        window.location = homepageEnabled
          ? `/homepage/${orgSlug}`
          : `/ui/${orgSlug}/incidents`
      })
    } else {
      checkResetPassUrlForTokens()
      startApp()
    }
  }

  if (isException) {
    startApp()
  } else {
    let configAuth = new XMLHttpRequest()
    configAuth.open('GET', '/api/config.json')
    configAuth.addEventListener('load', loadHandler)
    configAuth.send()
  }
}

export default notLoggedIn
